export default __webpack_public_path__ + "static/media/logo.1cc734a5.svg";